import { useEffect } from 'react';

const SEOSchema = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': siteUrl,
          url: siteUrl,
          name: 'Revive Nation \u2013 Reclaim Conference | SHAY Youth Revival Visakhapatnam 2025',
          description:
            'A powerful youth revival gathering across three locations in Visakhapatnam. April 11, 18 & 25, 2025 at 4 PM. Presented by SHAY & Bible Believers Tabernacle.',
          inLanguage: 'en',
          isPartOf: { '@type': 'WebSite', url: siteUrl },
        },
        {
          '@type': 'Organization',
          '@id': `${siteUrl}#organization`,
          name: 'SHAY',
          url: siteUrl,
          telephone: '+919502891444',
          sameAs: [
            'https://www.youtube.com/@ShayGeneration',
            'https://www.instagram.com/shay_this_generation',
            'https://www.facebook.com/profile.php?id=61578513957131',
            'https://whatsapp.com/channel/0029VbCjXXHFcow1ohd1CY09',
          ],
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Visakhapatnam',
            addressRegion: 'Andhra Pradesh',
            addressCountry: 'IN',
          },
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/71d6a8a551d583ad95743263bd4e0791.png',
          },
        },
        {
          '@type': 'EventSeries',
          '@id': `${siteUrl}#event-series`,
          name: 'Revive Nation \u2013 Reclaim Conference',
          description:
            'Revive Nation \u2013 Reclaim Conference is a youth-focused revival gathering carrying a burden for the next generation to be saved, restored, awakened, and established in the presence of God.',
          url: siteUrl,
          image:
            'https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/71d6a8a551d583ad95743263bd4e0791.png',
          organizer: { '@id': `${siteUrl}#organization` },
          eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
          eventStatus: 'https://schema.org/EventScheduled',
          isAccessibleForFree: true,
          subEvent: [
            {
              '@type': 'Event',
              name: 'Revive Nation \u2013 Reclaim Conference: Arilova',
              startDate: '2025-04-11T16:00:00+05:30',
              eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
              eventStatus: 'https://schema.org/EventScheduled',
              isAccessibleForFree: true,
              organizer: { '@id': `${siteUrl}#organization` },
              location: {
                '@type': 'Place',
                name: 'Arilova',
                url: 'https://maps.app.goo.gl/5SeBP2c5JtbELpTMA',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Arilova',
                  addressRegion: 'Visakhapatnam',
                  addressCountry: 'IN',
                },
              },
            },
            {
              '@type': 'Event',
              name: 'Revive Nation \u2013 Reclaim Conference: Madhurawada',
              startDate: '2025-04-18T16:00:00+05:30',
              eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
              eventStatus: 'https://schema.org/EventScheduled',
              isAccessibleForFree: true,
              organizer: { '@id': `${siteUrl}#organization` },
              location: {
                '@type': 'Place',
                name: 'Madhurawada',
                url: 'https://maps.app.goo.gl/o1wUS4msXwoj9RDy9',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Madhurawada',
                  addressRegion: 'Visakhapatnam',
                  addressCountry: 'IN',
                },
              },
            },
            {
              '@type': 'Event',
              name: 'Revive Nation \u2013 Reclaim Conference: Yendada',
              startDate: '2025-04-25T16:00:00+05:30',
              eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
              eventStatus: 'https://schema.org/EventScheduled',
              isAccessibleForFree: true,
              organizer: { '@id': `${siteUrl}#organization` },
              location: {
                '@type': 'Place',
                name: 'Yendada',
                url: 'https://maps.app.goo.gl/UrVabfG6nACTBy4m7',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Yendada',
                  addressRegion: 'Visakhapatnam',
                  addressCountry: 'IN',
                },
              },
            },
          ],
        },
      ],
    };

    const id = 'schema-org-jsonld';
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema, null, 2);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return null;
};

export default SEOSchema;